"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var PartnersOffersListCtl = /** @class */ (function (_super) {
    __extends(PartnersOffersListCtl, _super);
    function PartnersOffersListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_partner_login = UIUtils_1.UIUtils.IProp2Str(function (o) { o.partner_login; });
        _this.dk_brand_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_title; });
        _this.dk_affilate_offer_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.pprogram_offer_id; });
        _this.dk_affilate_offer_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.pprogram_offer_title; });
        _this.dk_date_added2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added2; });
        _this.dk_date_changed2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed2; });
        _this._errDialog = errDialog;
        return _this;
    }
    PartnersOffersListCtl.prototype.ResetData = function () {
        this.DATA = {
            total: 0,
            data: []
        };
    };
    PartnersOffersListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "partner offer with id [" + id + "] not found !";
    };
    PartnersOffersListCtl.prototype.LoadData = function (partnerId, onDone) {
        var _this = this;
        webAApi_1.ListPProgramPartnerOffersByPartnerIdGet.exec({ usr_partner_id: partnerId }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    partner_login: resp.list[i].partner_login,
                    brand_title: resp.list[i].brand_title,
                    date_added2: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed2: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    pprogram_offer_id: resp.list[i].brand_offer_id,
                    pprogram_offer_title: resp.list[i].brand_offer_title
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PartnersOffersListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddPProgramPartnerOffer.exec({
            data: {
                brand_offer_id: data.offer_id,
                usr_partner_id: data.usr_partner_id
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                pprogram_offer_id: data.offer_id,
                pprogram_offer_title: resp.offer_title,
                date_changed2: moment(resp.date_added_uts_ms).utc(false).utc(false),
                date_added2: moment(resp.date_added_uts_ms).utc(false).utc(false),
                partner_login: resp.partner_login,
                brand_title: resp.brand_title
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PartnersOffersListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditPProgramPartnerOffer.exec({
                data: {
                    usr_partner_offer_id: data.key,
                    brand_offer_id: data.offer_id
                }
            }, function (resp) {
                _tmp.pprogram_offer_id = data.offer_id;
                _tmp.pprogram_offer_title = resp.offer_title;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    PartnersOffersListCtl.prototype.RemoveItem = function (accessKey) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === accessKey) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    PartnersOffersListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeletePProgramPartnerOffer.exec({
                data: {
                    usr_partner_offer_id: key,
                }
            }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return PartnersOffersListCtl;
}(BaseController_1.BaseController));
exports.PartnersOffersListCtl = PartnersOffersListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_partners_list/ctl/PartnersOffersListCtl.ts
// module id = 964
// module chunks = 0